import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserManagement = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.125 13.75v-3h-3v-1.5h3v-3h1.5v3h3v1.5h-3v3h-1.5ZM9 11.692c-.963 0-1.786-.342-2.472-1.028C5.843 9.98 5.5 9.154 5.5 8.192s.343-1.786 1.028-2.472C7.214 5.035 8.038 4.692 9 4.692c.963 0 1.786.343 2.472 1.028.685.686 1.028 1.51 1.028 2.472 0 .963-.343 1.787-1.028 2.472-.686.686-1.51 1.028-2.472 1.028Zm-7.5 7.616v-2.224c0-.49.133-.943.399-1.36a2.663 2.663 0 0 1 1.067-.963 14.513 14.513 0 0 1 2.99-1.09 12.95 12.95 0 0 1 6.087 0c1.006.243 2.003.606 2.992 1.09.444.225.8.546 1.066.963.266.417.399.87.399 1.36v2.224h-15Z" })
});
export { SvgUserManagement as ReactComponent };
